module.exports = __webpack_public_path__ + "img/shopping_detail_2.29d0ea63.svg";